// WARNING: These styles were introduced for specific features and have not been verified across the whole app yet, nor validated in collaboration with our design team. The presence of these styles is gestural towards a coherent design system, but should not be used as a guide for other styles.
const borderRadius = {
  small: '2px',
  medium: '4px',
  large: '6px',
  xlarge: '8px',
  xxlarge: '10px',
  xxxlarge: '12px',
} as const;

const borderByComponent = {
  button: '8px',
  input: '4px',
};

export default { borderRadius, borderByComponent };
